import React from 'react';
import { Grid, Header } from 'semantic-ui-react';

export default function CallbackFailurePage(){
    return (
        <Grid verticalAlign="middle" centered style={{'padding': '120px'}}>
            <Grid.Row>
                <Grid.Column>
                    <Header size="large">Unfortunately your payment cannot be processed as your transaction has been declined.</Header>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
}
